import router from '@/router';

export const useSearchStore = defineStore('SearchStore', {
    state: () => ({
        searchKeyword: '',
    }),

    getters: {},

    actions: {
        handleSearch(keyword) {
            this.openSearch(keyword);
        },

        openSearch(keyword) {
            const nextKeyword = String(keyword || '').trim();
            this.searchKeyword = nextKeyword;

            if (nextKeyword) {
                void router.push({ name: 'page-search', query: { q: nextKeyword } });
                return;
            }

            void router.push({ name: 'page-search' });
        },
    },
});
